'use client';
import { useEffect } from 'react';
import { Input } from './Input';
import { useDebouncedSearch } from '../hooks/useDebouncedSearch';

// Reusable search input with built-in debounce (500ms default). Owns the input
// state and notifies the parent of the debounced query via onDebouncedChange,
// which the parent stores and feeds into its query. Replaces the repeated
// useDebouncedSearch + Input boilerplate across list tables.
export const InputDebounceSearch = ({
  className,
  placeholder,
  wait = 500,
  onDebouncedChange,
}: {
  className?: string;
  placeholder?: string;
  wait?: number;
  onDebouncedChange: (query: string) => void;
}) => {
  const { value, query, onChange } = useDebouncedSearch(wait);

  useEffect(() => {
    onDebouncedChange(query);
  }, [query, onDebouncedChange]);

  return (
    <Input
      className={className}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
    />
  );
};
